import { render, staticRenderFns } from "./MangeGiftProgramStatusDialog.vue?vue&type=template&id=ea4be97a&scoped=true"
import script from "./MangeGiftProgramStatusDialog.vue?vue&type=script&lang=js"
export * from "./MangeGiftProgramStatusDialog.vue?vue&type=script&lang=js"
import style0 from "./MangeGiftProgramStatusDialog.vue?vue&type=style&index=0&id=ea4be97a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea4be97a",
  null
  
)

export default component.exports